import { useState } from "react";
import styled from "styled-components";
import poster from "images/poster.png";

const StyledImg = styled.div`
  display: block;
  margin: 0;
`;

const PopupFrame = styled.div`
  display: ${(props) => (props.$visible ? "block" : "none")};
  position: fixed;
  top: 0px;
  left: 0px;
  width: 472px;
  z-index: 1000;
  color: white;

  @media (max-width: 490px) {
    width: 100%;
  }
`;

const CloseBar = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  // width: 427px;
  width: 100%;
  padding: 4px 10px;
  background-color: #282828;
  margin-top: -5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const PopupModal = ({ check }) => {
  const [visible, setVisible] = useState(check);

  const closeForADay = () => {
    const checkoutTime = new Date().getTime();
    localStorage.setItem("notice_checkout", checkoutTime);
    setVisible(false);
  };

  const close = () => {
    setVisible(false);
  };

  return (
    <div className="PopupModal">
      <PopupFrame $visible={visible}>
        <StyledImg>
          <img src={poster} alt="poster-image" width="100%" />
        </StyledImg>
        <CloseBar>
          <CloseButton onClick={closeForADay}>
            05시간 05분 동안 닫기
          </CloseButton>
          <CloseButton onClick={close}>닫기</CloseButton>
        </CloseBar>
      </PopupFrame>
    </div>
  );
};

export default PopupModal;
